module.exports = __webpack_public_path__ + "static/img/sgb.c82b5de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sgb.jpg
// module id = Xa8b
// module chunks = 0